import { z } from 'zod';

import { useAxleQuery } from '../apiHelpers';
import { type AppConfig, appConfigSchema } from './appConfig.schema';

export type { AppConfig };

export const useAppConfig = (): AppConfig =>
    useAxleQuery({
        path: '/app-config',
        suspense: true,
        responseSchema: z.object({ app_config: appConfigSchema }),
    }).data.app_config;
